/**
 * Shared math utilities for the client.
 */

export function shortAngleDist(from, to) {
  let diff = to - from;
  while (diff > Math.PI) diff -= Math.PI * 2;
  while (diff < -Math.PI) diff += Math.PI * 2;
  return diff;
}

export function lerp(a, b, t) {
  return a + (b - a) * t;
}

export function clamp(v, lo, hi) {
  return v < lo ? lo : v > hi ? hi : v;
}

/**
 * Frame-rate independent smoothing.
 *
 * `factor` is the fraction remaining after one second. v1 wrote the 60fps form
 * (`1 - 0.85 ** (delta * 60)`) inline in three places; this is the same curve
 * with the reference rate spelled out once.
 */
export function damp(delta, factor) {
  return 1 - Math.pow(factor, delta);
}

/** Ease-out cubic on 0..1: fast start, soft landing. */
export const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

/** Fade profile on 0..1: full strength until `holdFrac`, then linearly out. */
export const holdFade = (t, holdFrac = 0.6) => (t < holdFrac ? 1 : 1 - (t - holdFrac) / (1 - holdFrac));
